import { render } from "./AppSnackbar.vue?vue&type=template&id=4530bae4&ts=true"
import script from "./AppSnackbar.vue?vue&type=script&lang=ts"
export * from "./AppSnackbar.vue?vue&type=script&lang=ts"

import "./AppSnackbar.vue?vue&type=style&index=0&id=4530bae4&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__